import {Box, Button, Typography} from '@viptech/react-components'
import {useState} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {Input} from '../../../../../../../../components/input/Input'
import {ChosenObject} from '../../StepperModal'
import Card from '../../common/components/Card'
import {ContainerColumn} from './ConfigStepBase'

type Props = {
  chosen: ChosenObject | null
  toleranceThresholdValue: number
  setToleranceThresholdValue: (value: number) => void
}

const ToleranceThreshold = (props: Props) => {
  const {chosen, toleranceThresholdValue, setToleranceThresholdValue} = props
  const {styledTheme} = usePersonalizedThemeByCompany()
  const thresholds = [
    {id: 10, label: '10s'},
    {id: 60, label: '1min'},
    {id: 600, label: '10min'},
    {id: 3600, label: '1h'},
    {id: 7200, label: '2h'},
  ]

  const [showThresholdInput, setShowThresholdInput] = useState(!!!thresholds.find((it) => it.id === toleranceThresholdValue))

  const TitleAndLabelComponent = ({title, label}: {title: string; label: string}) => {
    return (
      <Box>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          {title}
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          {label}
        </Typography>
      </Box>
    )
  }

  if (
    !chosen?.detectionTypeChosen?.includes('Placa') &&
    !chosen?.detectionTypeChosen?.includes('Facial') &&
    !chosen?.detectionTypeChosen?.includes('Análise Demográfica')
  )
    return <></>

  return (
    <Box align='center' justifyContent='center'>
      <TitleAndLabelComponent title={'Tempo de Tolerância'} label={'Informe o intervalo de tempo para considerar uma nova detecção (em segundos)'} />

      <Box display='flex' columnGap='10px' align='center'>
        <ContainerColumn>
          {thresholds.map((it) => {
            return (
              <Card
                dispatchTo={it.label}
                selected={toleranceThresholdValue === it.id}
                initialState={!toleranceThresholdValue}
                onClick={() => setToleranceThresholdValue(it.id)}
                key={it.id}
              />
            )
          })}
        </ContainerColumn>
        {!showThresholdInput ? (
          <Button
            fontSize='12px'
            height='40px'
            width='150px'
            variant='outlined'
            color={styledTheme.colors.primary}
            marginTop='18px'
            onClick={() => setShowThresholdInput(true)}>
            Personalizar
          </Button>
        ) : (
          <Input.Root
            height='40px'
            width='150px'
            labelFontSize='12px'
            fontSize='12px'
            marginTop='18px'
            controlled
            value={String(toleranceThresholdValue)}
            rightIcon={<p style={{fontSize: '12px'}}>s</p>}
            onChange={(e) => setToleranceThresholdValue(Number(e.target.value))}
            borderColor={styledTheme.colors.primary}
          />
        )}
      </Box>
    </Box>
  )
}

export default ToleranceThreshold
